import React from "react";
import "./spinner.css";
import logo from "../../assets/logos/logo.png";

function Spinner () {

  return (
    <div className="pulse-logo">
      <img src={logo} className="logo" alt="Logo" />
      <h1 className="loader-p">Deine Ergebnisübersicht wird geladen.</h1>
    </div>

  );
}

export default Spinner;
